import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-gtm-loader',
  templateUrl: './gtm-loader.component.html'
})
export class GtmLoaderComponent implements OnInit {
  @Input() public gtmId: string;

  constructor() { }

  ngOnInit() {
    if (this.gtmId) {
      const innerText = ''
        + "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':"
        + "new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],"
        + "j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src="
        + "'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);"
        + `})(window,document,'script','dataLayer','${this.gtmId}');`;

      const scriptId = 'google-analytics';
      if (document.getElementById(scriptId)) {
        return;
      }
      const s = document.createElement('script') as any;
      s.type = 'text/javascript';
      s.id = scriptId;
      s.innerText = innerText;
      document.getElementsByTagName('head')[0].appendChild(s);

    }
  }
}
